import { TierRateByYear } from './../../interfaces';

export const rates: TierRateByYear = {
    2018: [
        { to: 12_500, percentage: 0 },
        { to: 25_000, percentage: .25 },
        { to: 50_000, percentage: .4 },
        { to: 75_000, percentage: .55 },
        { to: 1_060_000, percentage: .7 },
        { percentage: 2.35, base: 7420, offset: -1_060_000 }
    ],
    2019: [
        { to: 12_500, percentage: 0 },
        { to: 25_000, percentage: .25 },
        { to: 50_000, percentage: .35 },
        { to: 75_000, percentage: .5 },
        { to: 1_080_000, percentage: .65 },
        { percentage: 2.35, base: 7_020, offset: -1_080_000 }
    ],
    2020: [
        { to: 12_500, percentage: 0 },
        { to: 25_000, percentage: .2 },
        { to: 50_000, percentage: .35 },
        { to: 75_000, percentage: .45 },
        { to: 1_090_000, percentage: .6 },
        { percentage: 2.35, base: 6_540, offset: -1_090_000 }
    ],
    2021: [
        { to: 12_500, percentage: 0 },
        { to: 25_000, percentage: .2 },
        { to: 50_000, percentage: .3 },
        { to: 75_000, percentage: .4 },
        { to: 1_110_000, percentage: .5 },
        { percentage: 2.35, base: 5_550, offset: -1_110_000 }
    ],
    2022: [
        { to: 12_500, percentage: 0 },
        { to: 25_000, percentage: .15 },
        { to: 50_000, percentage: .25 },
        { to: 75_000, percentage: .35 },
        { to: 1_130_000, percentage: .45 },
        { percentage: 2.35, base: 5_085, offset: -1_130_000 }
    ],
    2023: [
        { to: 12_500, percentage: 0 },
        { to: 25_000, percentage: .1 },
        { to: 50_000, percentage: .2 },
        { to: 75_000, percentage: .25 },
        { to: 1_200_000, percentage: .35 },
        { percentage: 2.35, base: 4_200, offset: -1_200_000 }
    ],
    2024: [
        { to: 12_500, percentage: 0 },
        { to: 25_000, percentage: .1 },
        { to: 50_000, percentage: .2 },
        { to: 75_000, percentage: .25 },
        { to: 1_200_000, percentage: .35 },
        { percentage: 2.35, base: 4_620, offset: -1_320_000 }
    ]

};
